import React, { useState, useEffect } from 'react';
import { getActiveSpotlight, getSpotlightBids, placeSpotlightBid } from '../services/api';
import { useCustomerAuth } from '../services/CustomerAuthContext';

function HeroSpotlight() {
  const [spotlight, setSpotlight] = useState(null);
  const [bids, setBids] = useState([]);
  const [bidAmount, setBidAmount] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { customer } = useCustomerAuth();

  useEffect(() => {
    loadSpotlight();
    const interval = setInterval(loadSpotlight, 30000); // refresh every 30s
    return () => clearInterval(interval);
  }, []);

  async function loadSpotlight() {
    try {
      const data = await getActiveSpotlight();
      setSpotlight(data.spotlight);
      if (data.spotlight) {
        const bidData = await getSpotlightBids();
        setBids(bidData.bids || []);
      }
    } catch (err) {}
  }

  async function handleBid(e) {
    e.preventDefault();
    setError('');
    setSuccess('');
    const amount = Math.round(parseFloat(bidAmount) * 100);
    if (!amount || amount <= 0) { setError('Enter a valid bid amount'); return; }
    try {
      await placeSpotlightBid(amount);
      setSuccess('Bid placed!');
      setBidAmount('');
      loadSpotlight();
    } catch (err) {
      setError(err.error || 'Failed to place bid');
    }
  }

  function formatTimeRemaining(endTime) {
    const remaining = endTime - Math.floor(Date.now() / 1000);
    if (remaining <= 0) return 'Ended';
    const days = Math.floor(remaining / 86400);
    const hours = Math.floor((remaining % 86400) / 3600);
    const mins = Math.floor((remaining % 3600) / 60);
    return `${days}d ${hours}h ${mins}m remaining`;
  }

  if (!spotlight) {
    return (
      <section className="hero-spotlight">
        <h2 className="section-title">⚡ Spotlight Bid</h2>
        <p className="section-subtitle">No active spotlight right now — check back soon!</p>
      </section>
    );
  }

  return (
    <section className="hero-spotlight">
      <h2 className="section-title">⚡ Spotlight Bid</h2>
      <p className="section-subtitle">One vendor. One item. One week. Highest bid wins.</p>
      <div className="spotlight-bid">
        <div className="spotlight-badge">⚡ LIVE SPOTLIGHT</div>
        <div className="spotlight-card">
          <div className="spotlight-image">
            {spotlight.itemImage && <img src={spotlight.itemImage} alt={spotlight.itemName} />}
          </div>
          <div className="spotlight-info">
            <span className="vendor-tag">Vendor: {spotlight.vendorName}</span>
            <h3>{spotlight.itemName}</h3>
            <p className="spotlight-price">${(spotlight.currentBid / 100).toFixed(2)}</p>
            <p className="spotlight-meta">{spotlight.bidCount} bid{spotlight.bidCount !== 1 ? 's' : ''} • {formatTimeRemaining(spotlight.endTime)}</p>

            {customer ? (
              <form onSubmit={handleBid} className="bid-form">
                <input
                  type="number"
                  step="0.01"
                  placeholder={`Min $${((spotlight.currentBid + Math.max(1000, spotlight.currentBid * 0.02)) / 100).toFixed(2)}`}
                  value={bidAmount}
                  onChange={e => setBidAmount(e.target.value)}
                />
                <button type="submit" className="btn-bid">Bid</button>
              </form>
            ) : (
              <p className="spotlight-login-hint">Sign in to place a bid</p>
            )}
            {error && <p className="spotlight-error">{error}</p>}
            {success && <p className="spotlight-success">{success}</p>}
          </div>
        </div>
        {bids.length > 0 && (
          <div className="spotlight-bid-history">
            {bids.slice(0, 5).map((bid, i) => (
              <div className="bid-entry" key={i}>
                <span>${(bid.amount / 100).toFixed(2)}</span>
                <span className="bid-time">{new Date(bid.timestamp * 1000).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default HeroSpotlight;
